import { Injectable } from "@angular/core";
import { Storage } from "./storage";

@Injectable({
  providedIn: 'root'
})
export class IndexDBStorage implements Storage {

    private readonly dbName = 'restarunt-db';
    private readonly dbVersion = 1;
    private readonly storeName = 'restaurant';

    private dbPromise?: Promise<IDBDatabase>

    constructor(){
        this.dbPromise = this.openDataBase();
    }

    private openDataBase(): Promise<IDBDatabase> {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(
                this.dbName, 
                this.dbVersion
            );

            request.onupgradeneeded = () => {
                const db = request.result;

                // Si el store no existe, lo creamos
                if (!db.objectStoreNames.contains(this.storeName)) {
                    db.createObjectStore(this.storeName);
                }
            };

            request.onsuccess = () => {
                const db = request.result;

                db.onerror = () => {
                    console.error('IndexDB error');
                };

                resolve(db);

            };

            request.onerror = () => {
                reject(
                    request.error?? new Error('Unable to open IndexDB')

                );
            };
        });
    }

    async put<T>(key: string, value: T): Promise<void> {

        const db = await this.getDatabase();

        return new Promise((resolve, reject) => {

        const transaction = db.transaction(
            this.storeName,
            'readwrite'
        );

        const store = transaction.objectStore(
            this.storeName
        );

        store.put(value, key);

        transaction.oncomplete = () => {
            resolve();
        };

        transaction.onerror = () => {
            reject(
            transaction.error ??
            new Error('Unable to save data')
            );
        };

        transaction.onabort = () => {
            reject(
            transaction.error ??
            new Error('IndexedDB transaction aborted')
            );
        };
        });
    }

    async get<T>(key: string): Promise<T | null> {

        const db = await this.getDatabase();

        return new Promise((resolve, reject) => {

        const transaction = db.transaction(
            this.storeName,
            'readonly'
        );

        const store = transaction.objectStore(
            this.storeName
        );

        const request = store.get(key);

        request.onsuccess = () => {

            const value = request.result;

            resolve(
            value === undefined
                ? null
                : value as T
            );
        };

        request.onerror = () => {
            reject(
            request.error ??
            new Error('Unable to retrieve data')
            );
        };
        });
    }

    async remove(key: string): Promise<void> {

        const db = await this.getDatabase();

        return new Promise((resolve, reject) => {

        const transaction = db.transaction(
            this.storeName,
            'readwrite'
        );

        const store = transaction.objectStore(
            this.storeName
        );

        store.delete(key);

        transaction.oncomplete = () => {
            resolve();
        };

        transaction.onerror = () => {
            reject(
            transaction.error ??
            new Error('Unable to remove data')
            );
        };

        transaction.onabort = () => {
            reject(
            transaction.error ??
            new Error('IndexedDB transaction aborted')
            );
        };
        });
    }

    async clear(): Promise<void> {

        const db = await this.getDatabase();

        return new Promise((resolve, reject) => {

        const transaction = db.transaction(
            this.storeName,
            'readwrite'
        );

        const store = transaction.objectStore(
            this.storeName
        );

        store.clear();

        transaction.oncomplete = () => {
            resolve();
        };

        transaction.onerror = () => {
            reject(
            transaction.error ??
            new Error('Unable to clear storage')
            );
        };

        transaction.onabort = () => {
            reject(
            transaction.error ??
            new Error('IndexedDB transaction aborted')
            );
        };
        });
    }

    private async getDatabase(): Promise<IDBDatabase> {
        if (!this.dbPromise) {
        this.dbPromise = this.openDataBase();
        }

        return this.dbPromise;
    }

    
}